import React, { useEffect, useState } from "react";
import { Modal, Calendar, Input, Button, Typography, Row, Col, Alert } from "antd";
import dayjs from "dayjs";
import "./remoteMarkAttendanceModal.css";

const { Text } = Typography;

const RemoteMarkAttendanceModal = ({
  visible,
  onClose,
  onRemoteMark,
  checkInTime,
  checkOutTime,
  updateCalendar,
  isDisabled,
  statusLoading,
  existingShortLeave,
}) => {
  const [dateTime, setDateTime] = useState(dayjs());
  const [notes, setNotes] = useState("");

  // 🕒 Live date/time updater
  useEffect(() => {
    const timer = setInterval(() => setDateTime(dayjs()), 1000);
    return () => clearInterval(timer);
  }, []);

  // 🧹 Reset notes when modal closes
  useEffect(() => {
    if (!visible) {
      setNotes("");
    }
  }, [visible]);

  // 🚫 Disable all calendar dates
  const disableAllDates = () => true;

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={700} centered className="remote-attendance-modal">
      {/* Header with title and current time */}
      <Row justify="space-between" align="middle" style={{ marginTop: "1rem" }}>
        <Col>
          <Text strong className="attendance-modal-title">
            Remote Work Attendance / WFH
          </Text>
        </Col>
        <Col>
          <Text className="attendance-modal-time">
            {dateTime.format("DD-MMM-YYYY hh:mm:ss A")}
          </Text>
        </Col>
      </Row>

      {/* Calendar (disabled view) */}
      <div className="attendanceOverview-calendar-container mark-attendance-calendar-container" style={{ marginTop: "2rem" }}>
        <Calendar
          fullscreen={false}
          onChange={updateCalendar}
          disabledDate={disableAllDates}
        />
      </div>

      {existingShortLeave && (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 16 }}
          message="Short Leave Exists"
          description={
            existingShortLeave.leave_portion ===
            "first_half"
              ? "First-half leave already applied."
              : "Second-half leave already applied."
          }
        />
      )}

      {/* Notes field */}
      <div style={{ marginTop: "2rem" }}>
        <label className="form-label">Notes</label>
        <Input
          placeholder="Add remarks for remote attendance"
          value={notes}
          onChange={(e) => {
            const val = e.target.value;
            if (val.length <= 50) setNotes(val);
          }}
          onKeyDown={(e) => {
            if (
              notes &&
              notes.toString().length >= 50 &&
              !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                e.key
              )
            ) {
              e.preventDefault();
            }
          }}
        />
        <Text type="secondary" style={{ fontSize: 12 }}>
          {notes.length}/50 characters
        </Text>
      </div>

      {/* Check In / Out info */}
      <div className="check-container">
        <div>
          <span>Check In:</span>{" "}
          <span style={{ color: "green" }}>{checkInTime || "--"}</span>
        </div>
        <div>
          <span>Check Out:</span>{" "}
          <span style={{ color: "red" }}>{checkOutTime || "--"}</span>
        </div>
      </div>

      {/* Footer Buttons */}
      <div className="attendance-buttons">
        <Button onClick={onClose}>Discard</Button>
        <Button
          type="primary"
          loading={statusLoading}
          disabled={
            isDisabled || statusLoading || (checkInTime && checkOutTime) // Disable if both exist, or status not loaded yet
          }
          onClick={() =>
            onRemoteMark({
              notes,
              date: dateTime.format("YYYY-MM-DD"),
              time: dateTime.format("HH:mm:ss"),
            })
          }
        >
          {statusLoading
            ? "Checking status..."
            : !checkInTime
            ? "Remote Check-In"
            : checkInTime && !checkOutTime
            ? "Remote Check-Out"
            : "Marked"}
        </Button>
      </div>
    </Modal>
  );
};

export default RemoteMarkAttendanceModal;
